import {EntityWithIdAndDescription} from "../../types/baseEntities";
import {HttpAxiosRequest} from "../httpAxiosBase";
import {OperationReasonDestination} from "../../types/operationData";

export const HttpCacheOperation = {
    getEndpoint: (url: string): string => `cache/operacion${url}`,

    getRateModes: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpCacheOperation.getEndpoint(`/tasa-modos`)
        );
    },
    
    getPeriodicity: () : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpCacheOperation.getEndpoint(`/periodicidades`)
        );
    },
    
    getDestinations: () : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpCacheOperation.getEndpoint('/destinos')
        )
    },
    
    getReasonsDestination: () : Promise<OperationReasonDestination[]> => {
        return HttpAxiosRequest.get(
            HttpCacheOperation.getEndpoint('/destinos-motivos')
        )
    },
}